import { render } from "./ServiceCategoryDatatableFormCard.vue?vue&type=template&id=5568c7f7"
import script from "./ServiceCategoryDatatableFormCard.vue?vue&type=script&lang=js"
export * from "./ServiceCategoryDatatableFormCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__